/** @jsx jsx */
import React from "react";
import Accordion from "components/molecules/Accordion";
import DataTable from "components/organismos/DataTable/DataTable";
import { css, jsx } from "@emotion/core";
import { useHistory } from "react-router-dom";
import FlexBox from "components/atoms/FlexBox"; 
import { SubActionButton } from "components/atoms/Button";
import { ActionButton } from "components/atoms/Button/SubActionButton";
import moment from "moment";
import RejectedTransferDomain from "../domain/rejectedTransferDomain";
import Modal from "components/molecules/Modal";
import IconLabelButton from "components/molecules/IconLabelButton"; 
import { useApplyingTransferForm } from "../ApplyingTab/hook";
import ChangeLogModal from "components/molecules/ChangeLogModal";
import TextTooltip from "components/molecules/TextTooltip";

const TransferAccordion: React.FC<{ list: RejectedTransferDomain[] }> = ({
  list,
}) => {
  const history = useHistory();
  const {
    changeLogData,
    setChangeLogData,
    changeLogModalOpen,
    setChangeLogModalOpen,
    setSelectChangelog,
    fetchChangeLogTransfer,
  } = useApplyingTransferForm(list);

  const columns = React.useMemo(
    () => [
      {
        Header: "",
        id: "edit",
        accessor: "edit",
        Cell: (cell: {
          row: { isExpanded: boolean; original: any; index: number };
          data: any;
        }) => (
          <FlexBox customStyle={css({ justifyContent: "space-evenly" })}>
            <SubActionButton
              text="再申請"
              onClick={() => {
                sessionStorage.setItem(
                  "attendStampList.targetDateFrom",
                  moment(cell.row.original.stampListStartTime).format(
                    "YYYY-MM-DD"
                  )
                );
                sessionStorage.setItem(
                  "attendStampList.targetDateTo",
                  moment(cell.row.original.stampListEndTime).format(
                    "YYYY-MM-DD"
                  )
                );
                sessionStorage.setItem(
                  "attendStampList.orgCode",
                  String(cell.row.original.orgCode)
                );
                sessionStorage.setItem(
                  "attendStampList.staffCode",
                  String(cell.row.original.staffCode)
                );

                sessionStorage.setItem(
                  "application.orgCode",
                  String(cell.row.original.orgCode)
                );
                sessionStorage.setItem(
                  "application.staffCode",
                  String(cell.row.original.staffCode)
                );

                sessionStorage.setItem(
                  "application.dispStaffName",
                  `${cell.row.original.staffCode} ${cell.row.original.staffName}`
                );
                sessionStorage.setItem(
                  "application.targetDate",
                  moment(cell.row.original.targetDate).format("YYYY-MM-DD")
                );

                sessionStorage.setItem(
                  "application.returnDestination",
                  window.location.pathname
                );
                sessionStorage.setItem(
                  "attendStampList.returnDestination",
                  window.location.pathname
                );

                history.push("attendApplicationList/attendTransferApplication");
              }}
              action={ActionButton.EDIT}
            />
          </FlexBox>
        ),
        disableSortBy: true,
      },
      {
        Header: "差戻者",
        accessor: "authorizer",
      },
      {
        Header: "差戻日時",
        accessor: "approvalDate",
      },
      {
        Header: "申請者",
        accessor: "applicant",
        Cell: (cell: { row: { isExpanded: boolean; original: any } }) => (
          <div style={{ textAlign: "left" }}>
            {cell.row.original.staffCode}<br></br>{cell.row.original.staffName}
          </div>
        )
      },
      {
        Header: "申請日時",
        accessor: "applicationDate",
      },
      {
        Header: "申請\n種別",
        accessor: "modifiyStatusName",
      },
      {
        Header: "対象者",
        accessor: "targetPerson",
        Cell: (cell: { row: { isExpanded: boolean; original: any } }) => (
          <div style={{ textAlign: "left" }}>
            {cell.row.original.staffCode}<br></br>{cell.row.original.staffName}
          </div>
        )
      },
      {
        Header: (any: any) => "対象日付",
        id: "",
        accessor: "targetDate",
        Cell: (cell: {
          row: { isExpanded: boolean; original: any; index: number };
          data: any;
        }) => {
          return (
            <div style={{ textAlign: "center" }}>
              <div>
                <div>{cell.row.original.targetDate}</div>
                <IconLabelButton
                  onClick={() => {
                    fetchChangeLogTransfer(cell.row.original.rawData);
                    setChangeLogModalOpen(true);
                    setSelectChangelog("0");
                  }}
                  text="更新履歴"
                  textAlign="center"
                  isIcon={false}
                />
              </div>
            </div>
          );
        },
      },
      {
        Header: "振替休日",
        accessor: "transferHolidayDate",
      },
      {
        Header: "差戻者コメント",
        accessor: "rejectReason",
        Cell: (cell: {row: { isExpanded: boolean; original: any }})=>(
          <TextTooltip text={cell.row.original?.rejectReason} textDis={(
            <div className="ellipsis headline-cell-width-100"
              style={{
                textOverflow: 'ellipsis',
                whiteSpace: 'nowrap',
                overflow: 'hidden',
                width: '100px'
              }}>
                {cell.row.original?.rejectReason}
            </div>
          )} />  
        )
      },
    ],
    [history, fetchChangeLogTransfer, setChangeLogModalOpen, setSelectChangelog]
  );

  return (
    <React.Fragment>
      <div className="margin-accordian"
        css={css`
          table th:nth-of-type(1) {
            width: 50px;
          }
          table th:nth-of-type(2) {
            width: 120px;
          }
          table th:nth-of-type(3) {
            width: 80px;
            // white-space: pre-line;
          }
          table tbody tr td:nth-of-type(3) {
            text-align: center;
          }
          table th:nth-of-type(4) {
            width: 120px;
          }
          // table td:nth-of-type(4) {
          //   white-space: pre-line;
          // }
          table th:nth-of-type(5) {
            width: 120px;
            // white-space: pre-line;
          }
          table tbody tr td:nth-of-type(5) {
            text-align: center;
          }
          table th:nth-of-type(6) {
            width: 55px;
            white-space: pre;
          }
          table th:nth-of-type(6) span {
            display:block;
            margin: auto;
          }
          table th:nth-of-type(6) span svg {
            margin-left: 0!important;
          }
          table th:nth-of-type(7) {
            width: 120px;
          }
          table td:nth-of-type(7) {
            white-space: pre-line;
          }
          table th:nth-of-type(8) {
            width: 80px;
          }
          table th:nth-of-type(9) {
            width: 80px;
          }
          table th:nth-of-type(10) {
            width: 140px;
          }
        `}
      >
        <Accordion
          text={`振替申請 (${list.length}件）`}
          callBack={() => {}}
        >
          <div style={{ overflowX: "auto", whiteSpace: "nowrap", padding:'0 10px 10px' }}>
            <DataTable
              columns={columns}
              classNameParrant="border-left-right border-bottom"
              className="table-no-border-left-right"
              data={list}
              isGlobalFilter={true}
              minWidth="100%"
              sortBy={[{ id: "approvalDate", desc: true }]}
            />
          </div>
        </Accordion>
      </div>
      {/* Change log  */}
      <div css={css(">div>div{ width: 1000px }")}>
        <Modal
          closeHandler={() => {
            setChangeLogModalOpen(false);
            setChangeLogData([]);
          }}
          open={changeLogModalOpen}
          title="更新履歴"
          submitText="閉じる"
          onSubmit={() => {
            setChangeLogModalOpen(false);
            setChangeLogData([]);
          }}
          closeText=""
        >
          <ChangeLogModal changeLogData={changeLogData} request='振替申請'/>
        </Modal>
      </div>
      {/* ./Change log  */}
    </React.Fragment>
  );
};

export default TransferAccordion;
